{
  "#APP_OVERVIEW": {
    "ALL_APPLICATIONS": "All Applications",
    "MY_APPLICATIONS": "My Applications",
    "FAVORITES": "Favorites",
    "SEARCH": "Search all applications...",
    "GRID": "Grid View",
    "LIST": "List View",
    "INFO_TOOLTIP": "Show module info",
    "INFO": {
      "module": "Module",
      "library": "Library",
      "route": "Route",
      "permission": "Permission",
      "group": "Group"
    },
    "CONFIG_TITLE": "Configuration",
    "CONFIG_DEFAULT": "Default",
    "YES": "Yes",
    "NO": "No",
    "NOT_SET": "not set",
    "CONFIG": {}
  }
}
